import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCYD5af4I4d5OE8HzsQUJ_ZMgWNK7Fo6do",
    libraries: "places"
  }
});
